import { Notification } from '../../notifications/Notification';

export const projectIsValid = (notifications: Notification[]): boolean =>
  notifications.filter((notification) => notification.type === 'error').length === 0;
